import _Layout from "@arco-design/web-react/es/Layout";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import Nav from './common/nav';
import style from './style/page.less';
import PreviewContent from './common/nav/preview/content';
import lazyload from '@src/utils/lazyload';
var Feedback = lazyload(function () {
  return import('../common/feedback');
}, function () {
  return null;
});
var Page = function Page() {
  return /*#__PURE__*/React.createElement(_Layout, {
    className: style.page
  }, /*#__PURE__*/React.createElement(_Layout.Header, {
    className: style.nav
  }, /*#__PURE__*/React.createElement(Nav, {
    isPreviewPage: true
  })), /*#__PURE__*/React.createElement(PreviewContent, {
    themeInfo: __assign({}, window.themeConfig)
  }), /*#__PURE__*/React.createElement(Feedback, null));
};
export default Page;